export const ENUMERATED_DATA_ATTR = 'data-enumeration'
export const ENUMERATED_ELEMENT_CLASS = 'enumerated-element'
export const TOC_ANCHOR_CLASS = 'toc-anchor'
export const TOC_DATA_TEXT_ATTR = 'data-toc-text'

export const noopFunction = (): void => undefined
